import { render, staticRenderFns } from "./ND-PH-Notice.vue?vue&type=template&id=fa6d49a2&scoped=true&"
import script from "./ND-PH-Notice.vue?vue&type=script&lang=js&"
export * from "./ND-PH-Notice.vue?vue&type=script&lang=js&"
import style0 from "./ND-PH-Notice.vue?vue&type=style&index=0&id=fa6d49a2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa6d49a2",
  null
  
)

export default component.exports